module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "login-image hidden-sm-and-down",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/dashboard-bg.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-layout', {
    staticClass: "pa-3 sign-up",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'signUp'
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.signUp))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('h1', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.$lang.global.projectName))]), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.err) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-form', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "color": "primary",
      "type": "text",
      "name": "userName",
      "label": _vm.$lang.labels.username,
      "required": ""
    },
    model: {
      value: (_vm.formData.userName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "userName", $$v)
      },
      expression: "formData.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "color": "primary",
      "type": "password",
      "name": "password",
      "label": _vm.$lang.labels.password,
      "required": ""
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "disabled": _vm.loginProcessStarted,
      "color": "primary",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1), _vm._v(" "), (_vm.version) ? _c('v-layout', {
    staticClass: "justify-space-between",
    attrs: {
      "pt-3": "",
      "px-1": ""
    }
  }, [(_vm.version.fe) ? _c('span', {
    staticClass: "info-text"
  }, [_c('small', [_vm._v(_vm._s(_vm.$lang.labels.frontEndVersion) + ": " + _vm._s(_vm.version.fe))])]) : _vm._e(), _vm._v(" "), (_vm.version.be) ? _c('span', {
    staticClass: "info-text"
  }, [_c('small', [_vm._v(_vm._s(_vm.$lang.labels.backendversion) + ": " + _vm._s(_vm.version.be))])]) : _vm._e()]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eb1ef0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogIn.vue
// module id = 407
// module chunks = 35